'use strict';

var mealMenuTypes = ['Breakfast', 'Lunch', 'Brunch', 'Dinner'];

var nonMealMenuTypes = ["Hors d'Oeuvres", 'Interactive Experience'];

var e = mealMenuTypes.concat(nonMealMenuTypes);
e.mealMenuType = mealMenuTypes;
e.nonMealMenuTypes = nonMealMenuTypes;

module.exports = e;